import { ref } from "vue";
import { API } from "@/api/api";
import { Response } from "@/api/client";
import i18n from "@/plugins/i18n";
import { useError } from "@/composables/useError";
import type { QueryParams } from "@/api/types";
import type { ListResponseDto } from "@/api/dto/list-response.dto";
import type { Invoice } from "@/api/billing/dto/invoice";

const t = i18n.global.t;

export function useInvoices() {
  const api = new API();
  const { showAPIError } = useError();

  const isLoading = ref(false);

  async function fetchInvoices(query: QueryParams): Promise<ListResponseDto<Invoice> | null> {
    isLoading.value = true;

    try {
      const response = await api.billing.getInvoices(query);

      if (!response.success || !response.data) {
        showAPIError(response, t("billing.fetch-invoices-error"));
        return null;
      }

      return response.data;
    } catch (error) {
      console.error(error);
      showAPIError(Response.unknownError(), t("billing.fetch-invoices-error"));
      return null;
    } finally {
      isLoading.value = false;
    }
  }

  return {
    isLoading,
    fetchInvoices,
  };
}
